
namespace TabAurous.Common {

    @Serenity.Decorators.registerClass()
    export class RejectionForRepairSelectGrid extends _Ext.GridBase<Stock.StockItemRow,any> {
        protected getColumnsKey() { return 'Stock.StockItem'; } 
        protected getIdProperty() { return Stock.StockItemRow.idProperty; }
        protected getLocalTextPrefix() { return Stock.StockItemRow.localTextPrefix; }
        protected getService() { return Inventory.RejectionForRepairService.baseUrl; }
          
        constructor(container: JQuery, options) {
            super(container, options);
            (this.view.params as TransactionRequest).PartyId = options.GridFilters.PartyId;
                       
            new Serenity.HeaderFiltersMixin({
                grid: this
            });
            return this;
        }

        private autoSize;
         
        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        get selectedItems(): Stock.StockItemRow[] {
            var _this = this;
            var c = this.rowSelection.getSelectedAsInt32();
            //.map(function (x) { return _this.view.getItemById(x); });
            return this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
        }

        protected usePager() { return false; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };


        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
            //var request = this.view.params;
            //if (this.options.hideProducts && this.options.hideProducts.length)
            //    request.Criteria = Serenity.Criteria.and(request.Criteria, [["ProductID" /* ProductID */], 'not in', [this.options.hideProducts]]);
            return true;

        }

    } 
}